
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransactionService } from '../../../../../services/transaction.service';
import { ContainerType } from '../../../../../model/ContainerType';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-container-type-config',
  templateUrl: './container-type-config.component.html',
  styleUrls: ['./container-type-config.component.css']
})
export class ContainerTypeConfigComponent implements OnInit {
  containerTypes: ContainerType[] = [];
  form: FormGroup;
  isEdit: boolean = false;
  @ViewChild("formTransactionModal") formTransactionModal;
  loading: boolean = false;
  containerTypeUpdate: ContainerType | null = null;

  constructor(
    private transactionService: TransactionService,
    private modalService: NgbModal, 
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      baseRate: ['', Validators.required],
      transhipRate: ['', Validators.required],
      dailyRate: ['', Validators.required],
      freeDays: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.getContainerTypes();
  }

  getContainerTypes() {
    this.spinner.show();
    this.loading = true;
    this.transactionService.getContainerTypes().subscribe({
      next: (data) => {
        this.containerTypes = data;
        this.loading = false;
        this.spinner.hide();
      },
      error: () => { this.loading = false; this.spinner.hide(); }
    });
  }

  selectContainerType(containerType: ContainerType) {
    this.containerTypeUpdate = containerType;
    this.isEdit = true;
    this.form.patchValue(containerType);
  }

  clearForm() {
    this.form.reset();
    this.containerTypeUpdate = null;
    this.isEdit = false;
  }

  onSubmit() {
    if (this.form.invalid) return;
    const value = this.form.value;
    this.spinner.show();
    if (this.isEdit && this.containerTypeUpdate) {
      this.transactionService.updateContainerType((this.containerTypeUpdate as any).id, value).subscribe(() => {
        this.getContainerTypes();
        this.clearForm();
        this.cancelModal();
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        Swal.fire('Error', 'No se pudo actualizar el tipo de contenedor.', 'error');
      });
    } else {
      this.transactionService.createContainerType(value).subscribe(() => {
        this.getContainerTypes();
        this.clearForm();
        this.cancelModal();
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        Swal.fire('Error', 'No se pudo crear el tipo de contenedor.', 'error');
      });
    }
  }

  cancelModal() {
    this.containerTypeUpdate = null;
    this.modalService.dismissAll();
  }

  
  updateModal(containerType: ContainerType): void {
    this.containerTypeUpdate = containerType;
    this.isEdit = true;
    this.form.patchValue({
      name: containerType.name,
      description: containerType.description,
      code: containerType.code,
      baseRate: containerType.baseRate,
      dailyRate: containerType.dailyRate,
      freeDays: containerType.freeDays,
      transhipRate: containerType.transhipRate,
    });
    this.toggleModal(this.formTransactionModal);
  }


  toggleModal(modal: any): void {
    this.modalService.open(modal);
  }


  deleteContainerType(id: number) {
    Swal.fire({
      title: '¿Está seguro de eliminar este tipo de contenedor?',
      text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.transactionService.deleteContainerType(id).subscribe(() => {
          this.getContainerTypes();
          this.clearForm();
          this.spinner.hide();
          Swal.fire('Eliminado', 'El tipo de contenedor ha sido eliminado.', 'success');
        }, error => {
          this.spinner.hide();
          Swal.fire('Error', 'No se pudo eliminar el tipo de contenedor.', 'error');
        });
      }
    });
  }
}
